<template>
  <transition name="fade" appear>
    <div
      class="modal-overlay bg-white opacity-50 min-h-[100vh] max-w-[100vw] absolute left-0 right-0 bottom-0 top-0"
      v-show="showModal" @click.prevent="close()"></div>
  </transition>
  <transition name="pop" appear>
    <div class="modal absolute top-[90px] left-[50%] transform -translate-x-1/2 z-[99]" v-show="showModal"
      id="roadmap-page-block" role="dialog">
      <div id="login-dialog"
        class="dialog border border-[#E2E8F0] rounded-[8px] p-[20px] max-w-[670px] min-w-[670px] min-h-[500px] max-h-fit-content m-auto bg-white overflow-hidden text-center overflow-visible">
        <div>
          <div class="!relative overflow-hidden px-[40px] py-[30px]">
            <div @click="close"
              class="cursor-pointer close__btn absolute bg-[#ECF0FA] w-[32px] h-[32px] flex justify-center items-center rounded-[18px] right-[15px] top-[15px]">
            </div>
          </div>
          <div
            class="modal-body text-center flex flex-col max-w-full mx-auto text-left text-[#333] pt-0 m-0">
            <TitleComponent text="Reset password"
              class="body__title font-montserrat-semibold text-[38px] leading-[45px] text-vip-black px-[96px] mb-[35px]" />

            <input placeholder="Password" type="password" v-model="password" autocomplete="current-password"
             class="w-full border border-[#E2E8F0] rounded-[8px] py-[10px] px-[12px] mt-[20px]" />
            <span v-if="errors.password" class="text-red text-sm block text-left">{{ errors.password }}</span>

            <input placeholder="New password" type="password" v-model="newPassword" autocomplete="new-password"
             class="w-full border border-[#E2E8F0] rounded-[8px] py-[10px] px-[12px] mt-[20px]" />
            <span v-if="errors.newPassword" class="text-red text-sm block text-left">{{ errors.newPassword }}</span>

            <input placeholder="Re-enter new password" type="password" v-model="passwordConfirmation" autocomplete="new-password"
             class="w-full border border-[#E2E8F0] rounded-[8px] py-[10px] px-[12px] mt-[20px]" />
            <span v-if="errors.passwordConfirmation" class="text-red text-sm block text-left">{{ errors.passwordConfirmation }}</span>
            <button type="button"
              class="flex gap-[20px] items-center justify-center hover:!bg-[#000000] my-[40px] mx-auto block focus:!bg-[#000000] capitalize !bg-[#2B2B2B] text-white !min-h-[50px] !max-h-[60px] !w-[210px] button text-white font-montserrat-bold bg-blue-light text-[16px] font-bold rounded-[10px] disabled:opacity-50"
              :disabled="isSubmitting"
              @click="validateForm">
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import TitleComponent from '@/components/common/TitleComponent.vue';
import api from '@/helpers/api';

export default {
  emits: ['close'],
  name: 'PasswordResetModal',
  components: {
    TitleComponent,
  },
  props: {
    showModal: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      password: '',
      newPassword: '',
      passwordConfirmation: '',
      errors: {
        password: '',
        newPassword: '',
        passwordConfirmation: '',
      },
      isSubmitting: false,
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth < 768;
    },
  },
  mounted() {
   //
  },
  methods: {
    validateForm() {
      // Reset errors
      this.errors = {
        password: '',
        newPassword: '',
        passwordConfirmation: '',
      };

      // Validate current password
      if (!this.password) {
        this.errors.password = 'Current password is required.';
      }

      // Validate new password
      // if (!this.newPassword) {
      //   this.errors.newPassword = 'New password is required.';
      // } else if (this.newPassword.length < 8) {
      //   this.errors.newPassword = 'New password must be at least 8 characters long.';
      // }

      // Validate password confirmation
      if (!this.passwordConfirmation) {
        this.errors.passwordConfirmation = 'Please confirm your new password.';
      } else if (this.newPassword !== this.passwordConfirmation) {
        this.errors.passwordConfirmation = 'Passwords do not match.';
      }

      // If no errors, proceed with password reset
      if (!this.errors.password && !this.errors.newPassword && !this.errors.passwordConfirmation) {
        this.resetPassword();
      }
    },
    resetPassword() {
      this.isSubmitting = true;
      api.resetPassword(this.password, this.newPassword)
        .then((response) => {
          console.log('Password reset successful:', response);
          this.close();
        })
        .catch((error) => {
          console.error('Password reset failed:', error);
          this.errors.password = 'Failed to reset password. Please try again.';
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    close() {
      setTimeout(() => {
        this.$emit('close');
      }, 100);
    },
  },
};
</script>

<style scoped>
* {
  font-family: 'Jost-Regular', sans-serif;
}
@media (max-width: 900px) {
  #login-dialog {
    max-width: 750px;
    min-width: 750px;
    height: 276px;
  }
}
@media (max-width: 790px) {
  #login-dialog  {
    max-width: 650px;
    min-width: 650px;
    height: 276px;
    gap: 20px;
    grid-template-columns: 1fr 3fr;
  }
  #login-dialog .image__container {
    width: 280px;
  }
  #login-dialog .close__btn {
    right: 30px;
  }
}
@media (max-width: 680px) {
  #login-dialog {
    max-width: 90vw !important;
    min-width: 90vw !important;
    margin: auto;
    height: fit-content;
  }
  .body__title {
    font-size: 40px;
    line-height: 35px;
    padding: 0;
    margin: 20px 0; 
  }
}
@media (max-width: 540px) {
  #login-dialog {
    max-width: 90vw !important;
    min-width: 90vw !important;
    margin: 0 auto !important;
    height: fit-content;
  }
  .body__title {
    font-size: 40px;
    line-height: 35px;
    padding: 0;
    margin-bottom: 20px;
  }
}
</style>
